import VideoConfigCard, {
  VideoConfigCardContainer,
  VideoConfigCardHeader,
} from "../../UIComponents/VideoConfigCard/VideoConfigCard";
import "./BgColorConfig.less";
import BgColorChoseContainer from "./BgColorChoseContainer/BgColorChoseContainer";
import { observer } from "mobx-react";
import useCoverAndBg from "@/useStore/mixCutDetail/useCoverAndBg";
const BgColorConfig = observer((props) => {
  const { style } = props;
  const { bgColor } = useCoverAndBg();
  return (
    <VideoConfigCard style={style}>
      <VideoConfigCardContainer>
        <BgColorChoseContainer />
      </VideoConfigCardContainer>
    </VideoConfigCard>
  );
});
export default BgColorConfig;
